import {useAuth} from "./../../../contexts/AuthContext"
import React from "react";
import {Page} from "../../layout/Pages";
import ListViewTable from "../../elements/tables/ListViewTable";
import {useQuery} from "@tanstack/react-query";
import {PrimaryButton} from "../../elements/Buttons";
import {getClients} from "../../../api/clients";


const columns = [
    {
        accessorKey: "name",
        id: "name",
        header: "Name",
        enableColumnFilter: false
    },
    {
        accessorKey: "code",
        id: "code",
        header: "Code",
        enableColumnFilter: false
    },
]

export default function ClientList() {

    const {currentUser} = useAuth()

    const {isLoading, isError, isSuccess, data, error, refetch} = useQuery(
        ["clients", currentUser.id],
        () => getClients(),
        {refetchInterval: 1000 * 60 * 2} // 2 minutes
    )

    function getRowLink(row) {
        return `/clients/${row.original.id}/edit`;
    }

    return (
        <Page>
            <div className="px-2">
                <div className="sm:flex sm:items-center">
                    <div className="sm:flex-auto">
                        <h1 className="text-3xl font-bold leading-tight tracking-tight text-gray-900">Clients</h1>
                    </div>
                    <div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
                        <PrimaryButton label="Add Client" link={"/clients/new"}/>
                    </div>
                </div>
                <div className="flex flex-col">
                    <div className="sm:-my-2 sm:-mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">

                        <div
                            className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                            {isSuccess && data && (
                                <ListViewTable
                                    data={data}
                                    columns={columns}
                                    isLoading={isLoading}
                                    disableGlobalSearch={false}
                                    getRowLink={getRowLink}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </Page>
    )
}
